import type { IAppSettings } from "@/utils/types";

const settings: IAppSettings = {
  showCountdown: process.env.VUE_APP_SHOW_COUNTDOWN === "true",
  app: {
    name: process.env.VUE_APP_NAME || "",
    logo: {
      width: "65px",
      height: "20px",
    },
  },
  wallet: {
    name: "Superhero Wallet",
    url: "https://wallet.superhero.com",
  },
  networks: {
    ae_mainnet: {
      name: "Mainnet",
      networkId: "ae_mainnet",
      apiUrl: process.env.VUE_APP_MAINNET_API || "",
      websocketUrl: process.env.VUE_APP_MAINNET_WS || "",
      url: "https://mainnet.aeternity.io",
      middlewareUrl: "https://mainnet.aeternity.io/mdw",
      explorerUrl: "https://aescan.io",
      compilerUrl: "https://v7.compiler.aepps.com",
      disabled: true,
    },
    ae_uat: {
      name: "Testnet",
      networkId: "ae_uat",
      apiUrl: process.env.VUE_APP_TESTNET_API || "",
      websocketUrl: process.env.VUE_APP_TESTNET_WS || "",
      url: "https://testnet.aeternity.io",
      middlewareUrl: "https://testnet.aeternity.io/mdw",
      explorerUrl: "https://testnet.aescan.io",
      compilerUrl: "https://v7.compiler.aepps.com",
    },
  },
  languages: ["en"],
  social: {
    x: undefined,
  },
  avatarServiceUrl: "https://avatars.superherowallet.com/",
  vuetify: {
    defaults: {
      VBtn: {
        rounded: "xl",
        variant: "flat",
      },
      VCard: {
        rounded: "xl",
      },
      VField: {
        rounded: "xl",
      },
    },
    theme: {
      defaultTheme: "dark",
      themes: {
        dark: {
          dark: true,
          colors: {
            background: "#060606",
            primary: "#F5274E",
            secondary: "#E65290",
            surface: "#111212",
            primaryDark: "#060606",
            success: "#66E773",
            error: "#E84134",
          },
          variables: {
            "disabled-opacity": 0.6,
          },
        },
      },
    },
  },
};

export default settings;
